import axios from "axios";

const config = {
  withCredentials: true,
  headers: {
    withCredentials: true,
  },
};

const cleanParam = (value) => {
  if (value == null) return "";
  const text = String(value).trim();
  if (!text || text === "null" || text === "undefined") return "";
  return text;
};

const getResult = (data) => data?.data?.result;

export const getSalesOrderReportYears = async () => {
  try {
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/sales/sales-order-report-years`,
      config
    );
    return getResult(data) || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getSalesOrderReportMonths = async (year) => {
  const selectedYear = cleanParam(year);
  if (!selectedYear) return [];
  try {
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/sales/sales-order-report-months?year=${encodeURIComponent(
        selectedYear
      )}`,
      config
    );
    return getResult(data) || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getSalesOrderReportPorts = async () => {
  try {
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/sales/sales-order-report-ports`,
      config
    );
    return getResult(data) || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getSalesOrderReportSalespersons = async () => {
  try {
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/sales/sales-order-report-salespersons`,
      config
    );
    return getResult(data) || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const downloadSalesOrderReport = async (inputs = {}) => {
  const urlParams = new URLSearchParams();
  const from = cleanParam(inputs.from);
  const to = cleanParam(inputs.to);
  const year = cleanParam(inputs.year);
  const month = cleanParam(inputs.month);
  const port = cleanParam(inputs.port_no_and_name);
  const salesmanId = cleanParam(inputs.salesman_id);
  const salesmanName = cleanParam(inputs.salesman_name);

  if (from && to) {
    urlParams.set("from", from);
    urlParams.set("to", to);
  } else if (year) {
    urlParams.set("year", year);
    if (month) urlParams.set("month", month);
  }

  if (port) urlParams.set("port_no_and_name", port);
  if (salesmanId && salesmanName) {
    urlParams.set("salesman_id", salesmanId);
    urlParams.set("salesman_name", salesmanName);
  }

  try {
    const query = urlParams.toString();
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/sales/sales-order-report-excel${
        query ? `?${query}` : ""
      }`,
      config
    );
    const result = getResult(data);
    if (typeof result === "string" && /^https?:\/\//i.test(result.trim())) {
      return { url: result.trim(), message: data?.data?.message };
    }
    return {
      url: null,
      message: data?.data?.message || "No Result Found",
    };
  } catch (error) {
    console.log(error);
    return {
      url: null,
      message: error?.response?.data?.message || "No Result Found",
    };
  }
};
